export default __webpack_public_path__ + "static/media/vf-active.2fd193d1.svg";